module.exports = __webpack_public_path__ + "assets/img/deactivate.817f4b74.png";